import { Environment, ProductName } from '@finders/finder';

class EnvironmentImpl implements Environment {
  production = false;
  brand = ProductName.Prolia.toLowerCase();
  product = ProductName.Prolia;
  api = 'https://api.bcbufinder.amgen.com/amggraphql';
  pdfApi = 'https://api.bcbufinder.amgen.com/getProcessedPDF';
  emailApi = 'https://api.bcbufinder.amgen.com/emailLocations';
}

export const staticObjectEnv = {
  googleMapsApiKey: 'AIzaSyAvJMAyBccja-CK2buVn1DWKGTZ3Z_tUh4',
  recaptchaApiKey: '6LemqR8gAAAAAK7Uy33S14WYiVE1rLCvn45z-Ekm'
};

export const environment = new EnvironmentImpl();
